<template>
  <div
    class="p-sortingMouseStoker"
    :style="{ top: mouseStoker.top, left: mouseStoker.left }"
  >
    <v-card min-width="220">
      <v-card-text class="text-center">
        <v-icon>mdi-card-text-outline</v-icon>
        {{ `${itemCount}件のアイテム 移動中` }}
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'SortingMouseStoker',
  props: {
    itemCount: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data () {
    return {
      mouseStoker: {
        top: '0px',
        left: '0px'
      }
    }
  },
  mounted () {
    window.onmousemove = this.mouseMove
  },
  methods: {
    mouseMove: function (event) {
      this.mouseStoker.top = event.clientY - 50 + 'px'
      this.mouseStoker.left = event.clientX + 10 + 'px'
    }
  }
}
</script>

<style>
.p-sortingMouseStoker {
  position: fixed;
  width: 50px;
  height: 50px;
  z-index: 10;
  border-radius: 50%;
}
</style>
